import z from 'zod';
import { ApplicationTeamType } from '../../Applications/ApplicationsList/ApplicationsList.types';
import { FormStep } from '../../Form/FormContext';
import { Bounty } from '../BountyList/BountyList.types';

export const bountyFormSchema = z.object({
  idea: z.string().min(3, 'This field is required'),
  teamType: z.nativeEnum(ApplicationTeamType, {
    message: 'This field is required',
  }),
  teamDescription: z.string().min(3, 'This field is required'),
  email: z
    .string()
    .min(1, {
      message: 'This field is required',
    })
    .email(),
  estimatedCost: z
    .string()
    .min(3, 'This field is required')
    .optional()
    .or(z.literal('')),
  dateRange: z
    .object({
      from: z.coerce.date(),
      to: z.coerce.date(),
    })
    .optional(),
  demoURL: z.string().url().optional().or(z.literal('')),
});

export type BountyFormSchema = z.TypeOf<typeof bountyFormSchema>;

export const bountyFormSteps = (
  bounty: Bounty,
): FormStep<BountyFormSchema>[] => [
  {
    title: bounty.name,
    description: bounty.description,
    fieldNames: ['idea'],
  },
  {
    title: 'Introduce your team',
    fieldNames: ['teamType', 'teamDescription', 'email'],
  },
  {
    title: 'Share extra details',
    subtitle: '(optional)',
    fieldNames: ['estimatedCost', 'dateRange', 'demoURL'],
  },
];
